import LookBookPanel from '~/js/components/wedding-styler/look-book/LookBookPanel';

const {inspirations, inspirationURLParameter = '' } = sandals_app.page;

ReactDOM.render(
	<LookBookPanel
            inspirationsData={inspirations}
            inspirationIdParameter={inspirationURLParameter}
        />,
	document.getElementById('look-book-panel')
);
